import React, { useState, useEffect } from 'react';
import { Toast } from 'antd-mobile';
import ConfirmDialog from '@/components/dfCancelDialog';
import { sha1 } from '@/utils/SHA2';
import {
  formatDateTime,
  getQueryString,
  getCookie,
  unionFlag,
  checkUnifyShop
} from '@/utils';
import api from '@/common/api';
import Password from './password';
import Inputted from './inputted';
import { STEP_TITLE, STEP_LIMIT, STEP_WARN_TEXT } from './utils';
import { ReplaceText, TLang } from '@/utils/lang';

const { UMI_ENV } = process.env;


const InPassword = (props) => <Inputted type="password" {...props} />;
const SetPassword = (props) => <Inputted type="password" {...props} />;
const InSMS = (props) => <Inputted type="sms" {...props} />;
const SetPhone = (props) => <Inputted type="phone" {...props} />;

const PayPassword = (props) => {

  // let clearIntervalTime: any = null

  /** 当前状态的标记 */
  const [flow, setFlow] = useState<number>(0);
  /** 显示/隐藏的状态，默认隐藏 */

  /** 存储键盘输入的值 */
  const [values, setValues] = useState([]);
  /** 校验失败提示文案的sign,  */
  const [sign, setSign] = useState('');
  /** 第一次输入的密码 */
  const [oldValues, setOldValues] = useState([]);
  /** 短信验证码 */
  const [smsCode, setSmsCode] = useState([]);
  /** error 提示信息 */
  const [errorTips, setErrorTips] = useState('');
  /** mobile */
  const [mobile, setMobile] = useState('');

  /** 未设置支付密码弹框 */
  const [passwordShow, setPasswordShow] = useState(false);
  /** 退出设置支付密码弹框 */
  const [passwordOutShow, setPasswordOutShow] = useState(false);
  /** 输入的密码与设置密码不符弹框 */
  const [passwordResetShow, setPasswordResetShow] = useState(false);

  const [clearIntervalTime, setClearIntervalTime] = useState(null);

  const {
    userInfo = {},
    onClose,
    isShowOrHide = false,
    isOnlyPhone = false
  } = props;
  /**
   * 获取短信验证码
   */
  const getSms = (mobile = []) => {
    const tel = typeof mobile === 'object' ? mobile.join('') : mobile;
    const union =
      unionFlag() ||
      window.sessionStorage.getItem('dffl_union') ||
      getQueryString('union');
    const bodyData = {
      mobile: tel,
      smsType: 2,
      sourceSys: (union&&!checkUnifyShop()) ? 4 : 1, // 百福得4，官网1,
      sourceWay: 3,
      unionCode: union,
      businessType: null
    };
    // 如果重新设置了数组, businessType传1
    if (userInfo && !userInfo.mobile) {
      bodyData.businessType = 1;
    }

    api.getSmsHandle(bodyData).then((res) => {
      if (res && res.code === 200) {
        setFlow(2);
        setErrorTips('');
        setValues([]);
        setMobile(tel);
      } else {
        if (res && res.code === 121004) {
          setErrorTips(TLang('该手机号已被绑定', 'home', false, false, null) || '');
          return;
        }
        setErrorTips(res?.message || '');
      }
    });
  };

  /** 校验手机号 */
  const checkInPhone = (numbers: any) => {
    // 发送验证码
    getSms(numbers);
  };
  /**
   * 校验短信验证码
   */
  const valiSms = (code) => {
    const union =
      unionFlag() ||
      window.sessionStorage.getItem('dffl_union') ||
      getQueryString('union');
    const bodyData = {
      mobile: userInfo.mobile,
      smsType: 2,
      sourceSys: (union&&!checkUnifyShop()) ? 4 : 1, // 百福得4，官网1,
      sourceWay: 3,
      smsCode: code.join(''),
      updateTime: +new Date(),
      unionCode: union,
      businessType: null,
      code: ''
    };
    let url = '/usercoord/sms/external/validate';
    /**
     * TODO: 重新设置手机号码，获取短信验证码后，使用update接口
     */
    if (!userInfo.mobile || isOnlyPhone) {
      bodyData.mobile = mobile;
      bodyData.businessType = 1;
      bodyData.code = code.join('');
      bodyData.smsCode = null;
      url = '/user/info/external/mobile/update';
    }
    api.valiSmsOrBindMobile(url, bodyData).then((res) => {
      if (res && res.code == 200) {
        setValues([]);
        setErrorTips('');
        if (isOnlyPhone){
          Toast.success(TLang('绑定成功', 'home', false, false, null));
          props.createOrderCbk && props.createOrderCbk();
        } else {
          setFlow(3);
        }
      } else {
        let msg = (res && res.message) || '';
        if (res && res.code === 120001) {
          msg = TLang('验证码不正确，请重新输入', 'home', false, false, null);
        } else if (res && res.code === 121004){
          msg = TLang('该手机号已被绑定', 'home', false, false, null);
        }
        setErrorTips(msg || '');
        setValues([]);
      }
    });
  };

  /** 验证成功，进入设置密码Step */
  const inSMSOverHandle = (code) => {
    setSmsCode(code);
    // TODO: 短信验证码校验的API；
    setTimeout(() => {
      valiSms(code);
    }, 300);
  };
  /** 设置成功，进入密码确认Step */
  const setPSOverHandle = () => {
    setFlow(5);
    setValues([]);
  };

  /** TODO: 确认密码成功后, 调用接口 */
  const confirmPSHandle = (comfirmPwd) => {
    // 确认密码一致
    const pwd = comfirmPwd.join('');
    if (pwd === oldValues.join('')) {
      updatePayPwd(pwd);
    } else {
      setPasswordResetShow(true);
    }
  };

  /** 键盘change事件 */
  const changeHandle = (value) => {
    const currentValues = [...values];
    const len = currentValues.length;
    const limit = STEP_LIMIT[flow];
    /** 输入逻辑：1.输入超出， 2.点击delete按钮 */
    switch (true) {
      case value === 'x':
        if (len === 0) return;
        values.pop();
        break;
      case len >= limit:
        return;
      default:
        values.push(value);
        break;
    }
    setValues(JSON.parse(JSON.stringify(values)));
    // useEffect监听values
  };

  /*
   *有4位以上连续相同的数字或者4位递增或递减
   */
  const isSpecial = (password) => {
    let str = password.join('');
    const re = /(\d)\1{3,}/g;
    const isRight = re.test(str);

    str += '';
    const allRe = /\d/g;
    const re1 = /(\(.*\))\1{3,}/g;
    // 判断是否递增
    const increment = str.replace(allRe, function (x1, idx) {
      return `(${x1 - idx})`;
    });
    const isIncrement = re1.test(increment);
    // 判断是否递减
    const decrement = str.replace(allRe, function (x1, idx) {
      return `(${parseInt(x1) + idx})`;
    });
    const isDecrement = re1.test(decrement);
    return isIncrement || isDecrement || isRight;
  };

  /*
   *冻结倒计时
   */
  const pwdCountDown = (time: number) => {
    console.log('tip', time, clearIntervalTime);
    if (clearIntervalTime) {
      window.clearInterval(clearIntervalTime);
      setClearIntervalTime(null);
    }
    // eslint-disable-next-line radix
    let count = time / 1000;
    // count = parseInt(String(count) / 1000))
    let countDown = '';
    // 分 && 秒
    const timer = window.setInterval(() => {
      console.log('kkkkkk', count);
      const minute =
        count > 0
          ? count / 60 > 9
            ? parseInt(String(count / 60))
            : `0${parseInt(String(count / 60))}`
          : '00';
      const second =
        count > 0
          ? count % 60 > 9
            ? String(count % 60)
            : `0${String(count % 60)}`
          : '00';
      count--;
      countDown = `${minute}:${second}`;
      setErrorTips(`密码已被冻结，请${countDown}后再试`);
      if (count <= 1) {
        setErrorTips('');
        window.clearInterval(clearIntervalTime);
      }
    }, 1000);
    setClearIntervalTime(timer);
  };

  /**
   * 验证支付密码
   */
  const validatePayPwd = (pwds) => {
    const pwd = pwds.join('');
    const param = {
      // token: tk,
      password: pwd,
      tokenType: 2,
      validateTime: formatDateTime(new Date())
    };
    api.validatePaymentPwdHandle(param).then((res) => {
      if (res && res.Status == 200) {
        // 输入支付密码验证成功
        setErrorTips('');
        setValues([]);
        setMobile('');
        setOldValues([]);
        props.createOrderCbk && props.createOrderCbk();
      } else if (res && res.Status == 120026) {
        setValues([]);
        // 冻结倒计时
        if (res && res.data && res.data.expireTime) {
          pwdCountDown(res.data.expireTime);
        }
        // this.dongjieShow = true;
      } else {
        setErrorTips(res.message || '');
        setValues([]);
      }
    });
  };

  useEffect(() => {
    if(isOnlyPhone){
      setFlow(1);

    } else {
      if (userInfo?.hasPayPasswordSet) {
        setFlow(4);
      } else if (userInfo?.mobile) {
        getSms(userInfo?.mobile);
        setFlow(2);
      } else {
        setFlow(1);
      }

    }

  }, [userInfo]);

  useEffect(() => {
    console.log(flow, 'input over');
    const limit = STEP_LIMIT[flow];
    if (values.length !== limit) return;
    /** 输入完成，唤起接口 */

    switch (flow) {
      case 1:
        /** 输入手机号成功进入短信验证 */
        // this.setPhoneSuccess();
        return;
      case 2:
        /** 输入验证码成功后进入设置密码 */
        inSMSOverHandle(values);
        return;
      case 3:
        if (isSpecial(values)) {
          setValues([]);
          setErrorTips(TLang('输入的密码4位数字不能相同或连续', 'home', false, false, null));
          return;
        }
        setOldValues(values);
        setErrorTips('');

        /** 设置密码成功后进入确认输入密码 */
        setTimeout(() => {
          setPSOverHandle();
        }, 500);
        return;
      case 4:
        // 输入支付密码，调验证接口
        validatePayPwd(values);
        break;
      case 5:
        /** 确认密码成功后 */
        confirmPSHandle(values);

      default:
    }
  }, [values]);
  /** 弹窗返回处理 */
  const goBack = () => {
    /** 确认密码Step, 关闭弹窗，提示 */
    if ([3, 5].includes(flow)) {
      setPasswordOutShow(true);
      return;
    }
    if (isOnlyPhone){
      // 如果是验证码页面返回到手机号输入页面
      if (flow === 2) {
        setFlow(1);
        setValues([]);
        setErrorTips('');
        return;
      }
    }
    /** 关闭弹窗 */
    onClose && onClose();
  };

  /** 忘记密码 */
  const forgetPwHandle = () => {
    setPasswordShow(false);
    setErrorTips('');
    console.log('wangjimima', clearIntervalTime);
    if (clearIntervalTime) {
      window.clearInterval(clearIntervalTime);
      setClearIntervalTime(null);
    }
    /** 进入设置密码的流程, 1、判断是设置手机号 2、进入短信验证 */
    const { mobile: isHasPhone } = userInfo || {};
    if (isHasPhone) {
      getSms(isHasPhone);
      setFlow(2);
      setValues([]);
    } else {
      setFlow(1);
      setValues([]);
    }
  };


  /** Step渲染展示 */
  const renderCurrentStep = (flow: any, values: any, sign: any) => {
    switch (flow) {
      case 1:
        /** 设置手机号 * 步骤1 */
        return (
          <SetPhone
            values={values}
            callback={() => {
              checkInPhone(values);
            }}
            warnText={errorTips || STEP_WARN_TEXT[sign]}
          />
        );
      case 2:
        /** 短信验证 * 步骤2 */
        return (
          <InSMS
            values={values}
            resetSend={(phone) => {
              getSms(phone);
            }}
            phone={userInfo?.mobile || mobile}
            warnText={errorTips || STEP_WARN_TEXT[sign]}
          />
        );
      case 3:
        /** 设置密码 * 步骤3 */
        return (
          <SetPassword values={values} isShowTip={false} warnText={errorTips} />
        );
      case 4:
        /** 输入密码 * 步骤4 */
        // const limit = 2;
        // const stepWarn = STEP_WARN_TEXT[4](limit);
        return (
          <InPassword
            values={values}
            warnText={errorTips}
            callback={forgetPwHandle}
          />
        );
      case 5:
        /** 重新输入密码 * 步骤5 */
        return (
          <InPassword values={values} isShowTip={false} warnText={errorTips} />
        );
      default:
        return null;
    }
  };

  /**
   * 设置支付密码
   * @returns
   */
  const updatePayPwd = (pwd) => {
    const union =
      unionFlag() ||
      window.sessionStorage.getItem('dffl_union') ||
      getQueryString('union');
    const param = {
      // token: tk,
      code: smsCode.join(''),
      smsType: 2,
      sourceSys: (union&&!checkUnifyShop()) ? 4 : 1, // 百福得4，官网1,
      sourceSubSys: 0,
      updateTime: formatDateTime(new Date()),
      sourceWay: 3,
      payPassword: pwd,
      tokenType: 2,
      unionCode: union
    };
    api.setPaymentPwdHandle(param).then((res) => {
      if (res && res.Status == 200) {
        // 设置支付密码成功
        setErrorTips('');
        setValues([]);
        setMobile('');
        setOldValues([]);
        props.createOrderCbk && props.createOrderCbk();
        Toast.info(TLang('密码设置成功', 'home', false, false, null));
      } else {
        setErrorTips(res.message || '');
        setValues([]);
      }
    });
  };

  return (
    <div>
      {/* 输入密码 */}
      <Password
        visit={isShowOrHide}
        title={STEP_TITLE[flow]}
        goBack={() => {
          goBack();
        }}
        onChange={(value: any) => {
          changeHandle(value);
        }}
      >
        <div>{renderCurrentStep(flow, values, sign)}</div>
      </Password>
      {passwordShow && (
        <ConfirmDialog
          content={TLang('您还未设置支付密码,请先设置', 'home', false, false, null)}
          okButton={TLang('立即设置', 'home', false, false, null)}
          cancleButton={TLang('取消', 'home', false, false, null)}
          onSure={forgetPwHandle}
          onCancle={() => {
            setPasswordShow(false);
          }}
        />
      )}
      {passwordOutShow && (
        <ConfirmDialog
          content={TLang('是否退出设置支付密码', 'home', false, false, null)}
          okButton={TLang('设置密码', 'home', false, false, null)}
          cancleButton={TLang('退出', 'home', false, false, null)}
          onSure={() => {
            setPasswordOutShow(false);
          }}
          onCancle={() => {
            setPasswordOutShow(false);
            onClose && onClose();
          }}
        />
      )}
      {passwordResetShow && (
        <ConfirmDialog
          content={TLang('您输入的密码与设置密码不符， 请重新设置', 'home', false, false, null)}
          okButton={TLang('重新输入', 'home', false, false, null)}
          onSure={() => {
            setFlow(3);
            setValues([]);
            setOldValues([]);
            setErrorTips('');
            setPasswordResetShow(false);
          }}
          onCancle={() => {
            setPasswordResetShow(false);
          }}
        />
      )}
    </div>
  );
};

export default PayPassword;
